export default __webpack_public_path__ + "static/media/login-bg.f0489a2a.jpg";